import { InlineObjectDestination } from './inline-object-destination';
export class InlinePictureDestination extends InlineObjectDestination {
}
